import React from "react";
import { Outlet } from "react-router-dom";

const CustomerLeadRoot = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CustomerLeadRoot;
